import { createContext, useContext } from "react";

// Current-user context — set once in App(), consumed by NotesFeed and NoteCard
export const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);
